import { render, staticRenderFns } from "./ChartBooleanList.vue?vue&type=template&id=1c014968&scoped=true&"
import script from "./ChartBooleanList.vue?vue&type=script&lang=js&"
export * from "./ChartBooleanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c014968",
  null
  
)

export default component.exports